/**
 * El tope de lo que pueden pesar los adjuntos de un correo al deudor.
 *
 * **Un solo número, en un solo sitio.** Hasta el 19/10/2026 había tres: 25 MB
 * escritos a mano en el compositor del chat, otros 25 en «Lo hago yo», y 15 en
 * la ruta de AR. O sea que el front dejaba subir 20 MB y el servidor los
 * rechazaba después, cuando ya se habían subido a S3.
 *
 * Es NUESTRO, no el del proveedor, y vale para **los dos canales**: AR (Resend)
 * y recobro (Gmail). El contenido viaja en base64, que infla un 33%, así que
 * 15 MB de ficheros deja sitio de sobra por debajo del límite de cualquiera de
 * los dos.
 *
 * ── Por qué el mismo número en los dos canales ──────────────────────────────
 * Porque es el mismo gesto: una persona adjunta un fichero a un correo. Dos
 * topes distintos según la fase del expediente serían arbitrarios, y quien los
 * encontrara no sabría por qué el mismo PDF sale en un expediente y no en otro.
 *
 * ── Por qué el corte de verdad está en el servidor ──────────────────────────
 * El compositor suma el tamaño de lo que has subido del ordenador, pero un
 * documento que ya estaba en el expediente **no guarda su tamaño en Mongo**: se
 * le pregunta a S3 y puede no saberlo, y entonces en esa suma cuenta como cero.
 * El front avisa antes, para no subir en balde; quien corta es el servidor,
 * donde el contenido ya está leído y el peso es el real.
 */
const MAX_EMAIL_ATTACHMENTS_MB = 15;
const MAX_EMAIL_ATTACHMENTS_BYTES = MAX_EMAIL_ATTACHMENTS_MB * 1024 * 1024;

/** El mismo mensaje en los dos canales y en las dos pantallas. */
function mensajeDemasiadoGrande(totalBytes) {
  return (
    `Los adjuntos pesan ${Math.round(totalBytes / 1024 / 1024)} MB y el tope del ` +
    `correo son ${MAX_EMAIL_ATTACHMENTS_MB} MB. Manda un enlace en vez del ` +
    'fichero, o móntalo en varios correos.'
  );
}

module.exports = {
  MAX_EMAIL_ATTACHMENTS_MB,
  MAX_EMAIL_ATTACHMENTS_BYTES,
  mensajeDemasiadoGrande,
};
